<template>
  <div
    id="form-search-popover"
    class="container-app-search">

    <!-- HEADER SECTION -->
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header">
      <h4 class="title-tab-experience-manager">ANALYTIC DASHBOARD</h4>
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="openAddCanvas">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-form
            inline
            @keypress.13.prevent="filter(filter_data)">
            <j-select
              v-model="select_type"
              :options="options_search"
              :error-required="false"
              placeholder="Filter By"
              class="m__r--5"/>
            <b-form-input
              ref="filterInput"
              v-model="filter_data"
              placeholder="Search"
              style="width: 250px; height: 35px"/>
          </b-form>
        </b-form>
      </div>
    </div>

    <!-- CONTENT SECTION -->
    <div class="studio-page-content">
      <v-server-table
        v-show="load_first"
        ref="canvasTableComponent"
        :columns="columns"
        :options="table_options"
        class="jTable"
        @loading="loading"
        @loaded="loaded">

        <div
          slot="id"
          slot-scope="props"
          @click="openDetail(props.row)">
          {{ props.row.id }}
        </div>

        <div
          slot="name"
          slot-scope="props"
          @click="openDetail(props.row)">
          {{ props.row.name }}
        </div>

        <div
          slot="created_at"
          slot-scope="props"
          @click="openDetail(props.row)">
          {{ convertTimestamp(props.row.created_at) }}
        </div>

        <div
          slot="updated_at"
          slot-scope="props"
          @click="openDetail(props.row)">
          {{ convertTimestamp(props.row.updated_at) }}
        </div>

      </v-server-table>
      <jLoadingTable v-if="!load_first"/>
    </div>

    <b-popover
      ref="searchFormModal"
      :show.sync="popoverSearchShow"
      container="form-search-popover"
      target="targetSearch"
      placement="right">
      <div class="m__b--10">Search Data</div>
      <b-form
        inline
        @keypress.13.prevent="filter(filter_data)">
        <j-select
          v-model="select_type"
          :disabled="false"
          :options="options_search"
          class="m__r--5"/>
        <j-input
          v-model="filter_data"
          placeholder="Search"
          class="m__r--5"/>
        <b-button
          class="btn blue outline"
          style="margin-top: -19px;"
          @click="filter(filter_data)">
          <i class="fa fa-search bold" /> Search
        </b-button>
      </b-form>
    </b-popover>

    <b-modal
      ref="appAddCanvasModal"
      class="mod-form modal-add-form-data"
      centered
      no-close-on-esc
      no-close-on-backdrop>
      <div class="label-create-form-data">CREATE CANVAS</div>
      <b-form-group :class="{'error-input' : $v.canvas_data.name.$error}">
        <label> Name </label>
        <j-input
          v-model="$v.canvas_data.name.$model"
          :error-required="$v.canvas_data.name.$error"
          :max-length="255" />
      </b-form-group>
      <b-form-group :class="{'error-input' : $v.canvas_data.description.$error}">
        <label> Description </label>
        <j-textarea
          v-model="$v.canvas_data.description.$model"
          :error-required="$v.canvas_data.description.$error" />
      </b-form-group>
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeAddCanvas">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="createNewCanvas">
              Next
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars */
import { mapActions, mapState } from 'vuex';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jApiCanvas from '@/services/jApiCanvas';
import jwtDecode from 'jwt-decode';
import { required } from 'vuelidate/lib/validators';

export default {
  components: {
    jLoadingTable,
  },
  data() {
    return {
      popoverSearchShow: false,
      placeholder_add: 'Only lowercase characters and underscore "_" are allowed, ex: name_form',
      load_first: false,
      filter_data: '',
      select_type: 'name',
      data_table: [],
      canvas_data: {
        name: '',
        description: '',
      },
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      options_search: [
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Name',
          value: 'name',
        },
      ],
      columns: ['id', 'name', 'created_at', 'updated_at'],
      table_options: {
        headings: {
          id: 'ID',
          name: 'CANVAS NAME',
          created_at: 'CREATED DATE',
          updated_at: 'UPDATE DATE',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        columns: ['id', 'name', 'created_at', 'updated_at'],
        debounce: 1000,
        filterable: true,
        perPage: 1000,
        perPageValues: [5, 10, 20, 50, 100],

        requestAdapter(data) {
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              column: data.orderBy ? data.orderBy : 'created_date',
              ascending: !data.ascending,
              query: data.query ? data.query : '',
              query_type: data.query_type ? data.query_type : '',
            },
          };
        },
        requestFunction(data) {
          const list = jApiCanvas.getListCanvas(data.pagination);
          return list.catch((e) => {
            this.$store.commit('jStoreNotificationScreen/toggleProblem', e.message);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.recordsTotal ? data.recordsTotal : 0,
          };
        },
      },
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.canvasTableComponent.setFilter('');
      }
    },
  },
  mounted() {
    this.$refs.filterInput.focus();
  },
  methods: {
    ...mapActions('jStoreCanvas', ['getListCanvas', 'createCanvas', 'deleteCanvas']),

    loading(val) {
      const a = val;
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      if (this.filter_data) {
        if (this.select_type === 'name') {
          dataFilter.name = this.filter_data;
        } else {
          dataFilter.id = [this.filter_data];
        }
      }
      a.pagination.filter = JSON.stringify(dataFilter);
      a.pagination.sort = JSON.stringify({ updated_at: -1 });
      this.popoverSearchShow = false;
      if (this.load_first) {
        this.$refs.canvasTableComponent.loading = true;
        this.$refs.canvasTableComponent.data = [];
      }
    },
    loaded(data) {
      this.data_table = data.data;
      if (!this.load_first) {
        this.load_first = !this.load_first;
      }
    },
    filter(val) {
      this.$refs.canvasTableComponent.setFilter(val);
    },
    openDetail(data) {
      this.$router.push(`/canvas/update/${data.id}`);
    },
    validateData() {
      this.$v.canvas_data.$touch();
      return this.$v.canvas_data.$error;
    },
    openAddCanvas() {
      this.$refs.appAddCanvasModal.show();
    },
    closeAddCanvas() {
      this.canvas_data.name = '';
      this.canvas_data.description = '';
      this.$refs.appAddCanvasModal.hide();
    },
    createNewCanvas() {
      if (!this.validateData()) {
        const param = {
          name: this.canvas_data.name,
          description: this.canvas_data.description,
          widgets: [],
        };
        this.createCanvas(param).then((response) => {
          if (!response.error) {
            this.$router.push(`/canvas/update/${response.data.id}`);
          } else {
            // eslint-disable-next-line
            console.log('gagal');
            this.$store.commit('jStoreNotificationScreen/toggleProblem', response.message);
          }
        });

        this.canvas_data.name = '';
        this.canvas_data.description = '';
        this.$refs.appAddCanvasModal.hide();
      }
    },
    convertTimestamp(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },
  },
  validations() {
    return {
      canvas_data: {
        name: {
          required,
        },
        description: {

        },
      },
    };
  },
};
</script>

<style lang="scss">
  .jTable .select-input {
    height: 35px !important;
    font-family: 'Poppins-Regular' !important;
    font-size: 14px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/canvas/jCanvasList.vue